export default __webpack_public_path__ + "static/media/veh-9.a777535e.png";